import { __ } from '@wordpress/i18n';

const Dashboard = () => {
    return (
        <div className="p-4 bg-white rounded shadow-md">
            <h1 className="text-2xl font-bold mb-4">{ __( 'Dashboard', 'universal-blocks' ) }</h1>
            <p>{ __( 'Coming soon! Keep an eye out for this awesome new addition.', 'universal-blocks' ) }</p>
        </div>
    );
};

export default Dashboard;
